import { functions } from "../firebase";

export type FreeAccessResult = {
  active: boolean;
  expiresAt: string | null;
};

export const setCustomerFreeAccess = async (params: {
  communityId: string;
  userId: string;
  enabled: boolean;
  durationDays?: number | null;
}): Promise<FreeAccessResult> => {
  const callable = functions.httpsCallable("setCustomerFreeAccess");
  const result = await callable(params);
  return result.data as FreeAccessResult;
};
